import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import ReactPixel from 'react-facebook-pixel';
import { trackInitiateCheckout } from '../App';
export function FinalCTASection() {
  return <section className="py-32 bg-[#0a0a0a] text-center border-t border-white/5" data-id="element-59">
      <div className="container mx-auto px-4" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-61">
          <h2 className="text-4xl md:text-7xl lg:text-8xl font-['Bebas_Neue'] text-white mb-10 leading-tight" data-id="element-62">
            DISCIPLINA O EXCUSAS.
            <br data-id="element-63" />
            <span className="text-[#C9A84C]" data-id="element-64">ELEGÍ.</span>
          </h2>

          <Button size="lg" className="text-lg md:text-xl px-8 md:px-12 py-6 md:py-8 w-full md:w-auto" onClick={() => {
          trackInitiateCheckout();
          window.open('https://pzhbwp-zj.myshopify.com/cart/43946659938439:1', '_blank');
        }} data-id="element-65">
            UNIRME AL GRUPO PRIVADO
          </Button>

          <div className="flex items-center justify-center gap-2.5 mt-5 bg-[#C9A84C]/10 border border-[#C9A84C]/30 rounded-sm px-5 py-3 max-w-sm mx-auto" data-id="element-66">
            <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 text-[#C9A84C] shrink-0" data-id="element-67">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" data-id="element-68" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" data-id="element-69" />
            </svg>
            <p className="text-xs text-[#C9A84C] font-medium" data-id="element-70">
              Al pagar, el link del grupo llega{' '}
              <span className="font-bold" data-id="element-71">inmediatamente</span> a tu Gmail.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}